var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5008 15.9019V13.2642C17.5008 11.7898 17.5008 11.0527 17.0507 10.8692C16.6006 10.6858 16.0708 11.207 15.0113 12.2495C14.4598 12.7922 14.1392 12.909 13.3689 12.909C12.6862 12.909 12.3448 12.909 12.0996 13.0702C11.5966 13.4008 11.6675 14.0519 11.6675 14.583C11.6675 15.1141 11.5966 15.7652 12.0996 16.0958C12.3448 16.2571 12.6862 16.2571 13.3689 16.2571C14.1392 16.2571 14.4598 16.3738 15.0113 16.9165C16.0708 17.959 16.6006 18.4802 17.0507 18.2968C17.5008 18.1133 17.5008 17.3762 17.5008 15.9019Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.333H8.93874C6.22107 18.333 4.86224 18.333 3.91857 17.6681C3.6482 17.4777 3.40817 17.2517 3.20577 16.9973C2.49935 16.1091 2.49935 14.8302 2.49935 12.2724V10.1512C2.49935 7.68188 2.49935 6.44723 2.89013 5.46113C3.51836 3.87586 4.84696 2.62541 6.53132 2.03414C7.57904 1.66634 8.89086 1.66634 11.5145 1.66634C13.0137 1.66634 13.7633 1.66634 14.362 1.87651C15.3245 2.21438 16.0837 2.92892 16.4427 3.83479C16.666 4.39827 16.666 5.10379 16.666 6.51483V8.33301",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50065 10C2.50065 8.46588 3.7443 7.22222 5.27843 7.22222C5.83325 7.22222 6.48735 7.31944 7.02679 7.1749C7.50608 7.04647 7.88045 6.6721 8.00888 6.1928C8.15342 5.65336 8.05621 4.99926 8.05621 4.44444C8.05621 2.91032 9.29986 1.66667 10.834 1.66667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon-audio.c03d7309e5082748defb098429e24079.svg";
export { ForwardRef as ReactComponent };